export const GET_CITY_ALIAS = 'GET_CITY_ALIAS'
